import {authActionTypes} from "../actions/actionTypes";

const initialState = {
    loginInfo: null,
    verifyToken: null,
    verifyName: null
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case authActionTypes.SET_LOGIN:
            return {
                ...state,
                loginInfo: action.payload,
            }
        case authActionTypes.SET_LOGOUT:
            return {
                loginInfo: null,
            }
        case authActionTypes.SET_VERIFY_NAME:
            return {
                ...state,
                verifyName: action.payload,
            }
        case authActionTypes.SET_VERIFY_TOKEN:
            return {
                ...state,
                verifyToken: action.payload,
            }
        case authActionTypes.CLEAR_VERIFY:
            return {
                verifyToken: null,
                verifyName: null
            }
        default:
            return state
    }
};